import { render, staticRenderFns } from "./AutomaticAccountingRecording.vue?vue&type=template&id=b84138ca&"
import script from "./AutomaticAccountingRecording.vue?vue&type=script&lang=js&"
export * from "./AutomaticAccountingRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports